import { GET, POST } from "../config/axios.config";
import { normalizeRecipes } from "./normalizers";

/**
 * Priced recipes sit behind a paywall: the public detail response withholds
 * ingredients and steps (`isLocked: true`) until the caller has a settled
 * purchase. One endpoint covers both gateways — the method is in the body.
 *
 * @param {"eps"|"stripe"} method
 * @returns {Promise<{ purchase, redirectUrl? }>}
 */
export const purchaseRecipe = async (recipeId, method = "eps") => {
  const res = await POST(`/recipes/${recipeId}/purchase`, {
    method,
    client: "web",
  });
  return res?.data || null;
};

/** Confirms a returning Stripe checkout for a recipe purchase. */
export const verifyRecipePurchase = (transactionId) =>
  GET(`/recipes/purchases/stripe/verify/${encodeURIComponent(transactionId)}`);

/** Asks the API to confirm a returning EPS recipe purchase with EPS itself. */
export const verifyEpsRecipePurchase = (transactionId) =>
  GET(`/recipes/purchases/eps/verify/${encodeURIComponent(transactionId)}`);

/** Rows are `{ purchase, recipe }` pairs; only the recipe is of interest here. */
export const listMyPurchasedRecipes = async ({ page = 1, limit = 50 } = {}) => {
  const res = await GET("/recipes/me/purchases", { params: { page, limit } });
  const rows = Array.isArray(res?.data) ? res.data : [];
  return normalizeRecipes(rows.map((row) => row.recipe).filter(Boolean));
};
